import pxToRem from "hooks/usePxToRem";

import {Grid} from "@mui/system";

import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {ProcessDatePicker} from "components";
import ProcessSelect from "views/ProcessDetails/refactor/components/ProcessSelect";
import ProcessTextField from "../../../ProcessTextField";

const BasicRateInfo = () => {
  const {control} = useFormContext();

  return (
    <Grid
      container
      rowSpacing={pxToRem(10)}
      columnSpacing={pxToRem(4)}
      mt={pxToRem(10)}
    >
      <Grid size={3}>
        <Controller
          name="charges.rate"
          control={control}
          render={({field: {onChange, value}}) => (
            <ProcessTextField
              name="charges.rate"
              value={value ?? ""}
              onChange={onChange}
              disabled
              label="Taxa"
              fullWidth
            />
          )}
        />
      </Grid>

      <Grid size={3}>
        <Controller
          name="charges.originCharge"
          control={control}
          render={({field: {onChange, value}}) => (
            <ProcessSelect
              name="charges.originCharge"
              value={value ?? ""}
              onChange={onChange}
              data={["Frete", "Destino", "Outros"]}
              size="small"
              disabled
              label="Origem Taxa"
              fullWidth
            />
          )}
        />
      </Grid>

      <Grid size={3}>
        <Controller
          name="charges.dateExpiry"
          control={control}
          render={({field: {value}}) => (
            <ProcessDatePicker
              name="charges.dateExpiry"
              value={value ?? ""}
              fullWidth
              disabled
              label="Data Validade"
            />
          )}
        />
      </Grid>

      <Grid size={3}>
        <Controller
          name="charges.typeService"
          control={control}
          render={({field: {onChange, value}}) => (
            <ProcessTextField
              name="charges.typeService"
              value={value ?? ""}
              onChange={onChange}
              disabled
              label="Tipo Serviço"
              fullWidth
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default memo(BasicRateInfo);
